export default __webpack_public_path__ + "static/media/ic_close_session.368cfa71.svg";